
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as index1YJbkkINsLgY_GwliAoND0v_0l30_MwuO0yM2a4DtjQMeta } from "/home/runner/work/EConnect.Web.Site/EConnect.Web.Site/app/pages/index.vue?macro=true";
import { default as start_45lab2tpGRD6ccrwvUQih0hQEywD_U8eQ_t_ovjBAJh84NZMMeta } from "/home/runner/work/EConnect.Web.Site/EConnect.Web.Site/app/pages/start-lab.vue?macro=true";
import { default as _404sY_mgIYCczTtPQl0V0RMPFTX3PnW2V87taR4aQE8CC2oMeta } from "/home/runner/work/EConnect.Web.Site/EConnect.Web.Site/app/pages/admin/404s.vue?macro=true";
import { default as loopsuu6gdpFjyv7fNXtfmLwC5a4CYvdLsiActNs5Y0twZjAMeta } from "/home/runner/work/EConnect.Web.Site/EConnect.Web.Site/app/pages/admin/loops.vue?macro=true";
import { default as imageslrQgFMt6JyAUMl6b63FsM05zN_9LzoUYH4h4ErB0PB0Meta } from "/home/runner/work/EConnect.Web.Site/EConnect.Web.Site/app/pages/admin/images.vue?macro=true";
import { default as indexIa7sObJWh6hsmZzcHgqVvTcs44LFTp8NzyMGaEigjXwMeta } from "/home/runner/work/EConnect.Web.Site/EConnect.Web.Site/app/pages/[locale]/index.vue?macro=true";
import { default as _91_46_46_46slug_93eUUQGb152Atc1qZd01HVKsjNpLHFG3SHMx3XlwsmqGcMeta } from "/home/runner/work/EConnect.Web.Site/EConnect.Web.Site/app/pages/[locale]/[...slug].vue?macro=true";
import { default as _91_91pageType_93_93oTCDNmM0CCOR29ubCGfDR4JeDzhaOma28rcobixgyBUMeta } from "/home/runner/work/EConnect.Web.Site/EConnect.Web.Site/app/pages/start/[[pageType]].vue?macro=true";
import { default as index9_J77DrfL1uWeOU1RMHP_DpotbGjrnKN2DZ0AHsVW5cMeta } from "/home/runner/work/EConnect.Web.Site/EConnect.Web.Site/app/pages/[locale]/docs/index.vue?macro=true";
import { default as _91_46_46_46slug_93XL_lBfQqT7R8IJ1lldP4Bm_7Eeuxf_9akDaOcF0hK_4Meta } from "/home/runner/work/EConnect.Web.Site/EConnect.Web.Site/app/pages/[locale]/docs/[...slug].vue?macro=true";
import { default as sign_45in_45requiredbHsi482yu8hqfHPexJ_z34qhiLbhqr3HWJ1afrMF7QsMeta } from "/home/runner/work/EConnect.Web.Site/EConnect.Web.Site/app/pages/[locale]/sign-in-required.vue?macro=true";
import { default as indexn87hm_K8D6drpxj_SiE6FjySb1yEhKdhGcevi21TWbcMeta } from "/home/runner/work/EConnect.Web.Site/EConnect.Web.Site/app/pages/[locale]/docs/[site]/index.vue?macro=true";
import { default as indexqdYEg5VAggvsZfTX8PneaxyeOIM0pAovztKzeGiD0CgMeta } from "/home/runner/work/EConnect.Web.Site/EConnect.Web.Site/app/pages/[locale]/docs/[site]/[category]/index.vue?macro=true";
import { default as indexuiSb1kFelKLTb3pKnixeLETjTLdftDrjBBIw3VQnawwMeta } from "/home/runner/work/EConnect.Web.Site/EConnect.Web.Site/app/pages/[locale]/docs/[site]/[subsite]/[category]/index.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    meta: index1YJbkkINsLgY_GwliAoND0v_0l30_MwuO0yM2a4DtjQMeta || {},
    component: () => import("/home/runner/work/EConnect.Web.Site/EConnect.Web.Site/app/pages/index.vue")
  },
  {
    name: "start-lab",
    path: "/start-lab",
    meta: start_45lab2tpGRD6ccrwvUQih0hQEywD_U8eQ_t_ovjBAJh84NZMMeta || {},
    component: () => import("/home/runner/work/EConnect.Web.Site/EConnect.Web.Site/app/pages/start-lab.vue")
  },
  {
    name: "admin-404s",
    path: "/admin/404s",
    meta: _404sY_mgIYCczTtPQl0V0RMPFTX3PnW2V87taR4aQE8CC2oMeta || {},
    component: () => import("/home/runner/work/EConnect.Web.Site/EConnect.Web.Site/app/pages/admin/404s.vue")
  },
  {
    name: "admin-loops",
    path: "/admin/loops",
    meta: loopsuu6gdpFjyv7fNXtfmLwC5a4CYvdLsiActNs5Y0twZjAMeta || {},
    component: () => import("/home/runner/work/EConnect.Web.Site/EConnect.Web.Site/app/pages/admin/loops.vue")
  },
  {
    name: "admin-images",
    path: "/admin/images",
    meta: imageslrQgFMt6JyAUMl6b63FsM05zN_9LzoUYH4h4ErB0PB0Meta || {},
    component: () => import("/home/runner/work/EConnect.Web.Site/EConnect.Web.Site/app/pages/admin/images.vue")
  },
  {
    name: "locale",
    path: "/:locale()",
    meta: indexIa7sObJWh6hsmZzcHgqVvTcs44LFTp8NzyMGaEigjXwMeta || {},
    component: () => import("/home/runner/work/EConnect.Web.Site/EConnect.Web.Site/app/pages/[locale]/index.vue")
  },
  {
    name: "locale-slug",
    path: "/:locale()/:slug(.*)*",
    meta: _91_46_46_46slug_93eUUQGb152Atc1qZd01HVKsjNpLHFG3SHMx3XlwsmqGcMeta || {},
    component: () => import("/home/runner/work/EConnect.Web.Site/EConnect.Web.Site/app/pages/[locale]/[...slug].vue")
  },
  {
    name: "start-pageType",
    path: "/start/:pageType?",
    meta: _91_91pageType_93_93oTCDNmM0CCOR29ubCGfDR4JeDzhaOma28rcobixgyBUMeta || {},
    component: () => import("/home/runner/work/EConnect.Web.Site/EConnect.Web.Site/app/pages/start/[[pageType]].vue")
  },
  {
    name: "locale-docs",
    path: "/:locale()/docs",
    meta: index9_J77DrfL1uWeOU1RMHP_DpotbGjrnKN2DZ0AHsVW5cMeta || {},
    component: () => import("/home/runner/work/EConnect.Web.Site/EConnect.Web.Site/app/pages/[locale]/docs/index.vue")
  },
  {
    name: "locale-docs-slug",
    path: "/:locale()/docs/:slug(.*)*",
    meta: _91_46_46_46slug_93XL_lBfQqT7R8IJ1lldP4Bm_7Eeuxf_9akDaOcF0hK_4Meta || {},
    component: () => import("/home/runner/work/EConnect.Web.Site/EConnect.Web.Site/app/pages/[locale]/docs/[...slug].vue")
  },
  {
    name: "locale-sign-in-required",
    path: "/:locale()/sign-in-required",
    component: () => import("/home/runner/work/EConnect.Web.Site/EConnect.Web.Site/app/pages/[locale]/sign-in-required.vue")
  },
  {
    name: "locale-docs-site",
    path: "/:locale()/docs/:site()",
    meta: indexn87hm_K8D6drpxj_SiE6FjySb1yEhKdhGcevi21TWbcMeta || {},
    component: () => import("/home/runner/work/EConnect.Web.Site/EConnect.Web.Site/app/pages/[locale]/docs/[site]/index.vue")
  },
  {
    name: "locale-docs-site-category",
    path: "/:locale()/docs/:site()/:category()",
    meta: indexqdYEg5VAggvsZfTX8PneaxyeOIM0pAovztKzeGiD0CgMeta || {},
    component: () => import("/home/runner/work/EConnect.Web.Site/EConnect.Web.Site/app/pages/[locale]/docs/[site]/[category]/index.vue")
  },
  {
    name: "locale-docs-site-subsite-category",
    path: "/:locale()/docs/:site()/:subsite()/:category()",
    meta: indexuiSb1kFelKLTb3pKnixeLETjTLdftDrjBBIw3VQnawwMeta || {},
    component: () => import("/home/runner/work/EConnect.Web.Site/EConnect.Web.Site/app/pages/[locale]/docs/[site]/[subsite]/[category]/index.vue")
  }
]